export const UNSPLASH_URL = 'unsplash';
export const DEFAULT_UNSPLASH_QUERY_WORD = 'minimal';
export const PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD = 'color';
